<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{ label: string; modelValue: string; max?: string | undefined; invalid?: boolean | undefined }>()
const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const { locale } = useI18n()
</script>

<template>
  <label class="flex items-center gap-2 text-[length:var(--text-step-2)] text-[color:var(--color-text)]">
    <span class="text-[color:var(--color-text-muted)]">{{ label }}</span>
    <span class="relative flex items-center">
      <svg
        aria-hidden="true"
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        class="pointer-events-none absolute left-[var(--space-cell)] text-[color:var(--color-text-muted)]"
      >
        <rect x="2" y="3" width="12" height="11" rx="2" />
        <path d="M2 6.5h12M5.5 1.5v3M10.5 1.5v3" />
      </svg>
      <input
        type="date"
        :lang="locale"
        :max="max"
        :value="modelValue"
        :aria-invalid="invalid || undefined"
        class="min-h-[var(--density-control)] min-w-[10rem] rounded-[var(--radius-control)] border border-[color:var(--color-border-control)] bg-[color:var(--color-surface)] py-1 pl-8 pr-[var(--space-cell)] text-[length:var(--text-step-3)] text-[color:var(--color-text)] outline-none aria-[invalid=true]:border-[color:var(--color-danger)]"
        @change="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      />
    </span>
  </label>
</template>
